// extracted by mini-css-extract-plugin
export var arrows = "_6q-6";
export var decrementer = "_6q-a";
export var disabled = "_6q-4";
export var error = "_6q-1";
export var hiddenText = "_6q-b";
export var incrementer = "_6q-9";
export var input = "_6q-8";
export var inputWrapper = "_6q-0";
export var leadingIcon = "_6q-c";
export var readonly = "_6q-3";
export var regular = "_6q-7";
export var small = "_6q-5";
export var warning = "_6q-2";